export const ACCEPT = '.jpg,.jpeg,.png,image/jpeg,image/png';
export const ALLOWED_TYPES = ['image/jpeg', 'image/png'];
export const MAX_LAYER_SIZE = 0.85;
export const CROP_PADDING_PX = 8;

export function readFileAsDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}